<!-- <div class="inpage-ad">
  <iframe id="id{{ adUnitId }}" name="{{ adUnitId }}"
          [src]="iframeUrl"
          frameBorder="0" frameSpacing="0" scrolling="no" width="{{ width }}" height="{{ height }}">
    <a [href]="anchorUrl">
      <img [src]="imageUrl" border="0"
           alt="">
    </a>
  </iframe>
</div> -->

<div class="inpage-ad">
  <dfp-ad [adUnit]="adUnitId">
    <dfp-size [width]="width" [height]="height"></dfp-size>
    <dfp-targeting key="pos" [value]="position"></dfp-targeting>
    <dfp-targeting *ngIf="ident && ident.length > 0" key="faaident" [value]="ident"></dfp-targeting>
  </dfp-ad>
</div>
